import { useNavigate } from 'react-router-dom';
import { ImageUpload } from '@/components/ImageUpload';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { AVAILABLE_CATEGORIES, getCategoryConfig } from '@/constants/categories';
import { useProductWorkflow } from '@/hooks/useProductWorkflow';
import type { ProductCategory } from '@/types';

export function UploadPage() {
  const navigate = useNavigate();
  const {
    masterImage,
    productTitle,
    productCategory,
    handleImageSelect,
    handleClearImage,
    setProductTitle,
    setProductCategory,
    handleStartCropping,
  } = useProductWorkflow();

  const onStartCropping = () => {
    handleStartCropping();
    navigate('/crop');
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-bold mb-2">Start New Product</h2>
        <p className="text-muted-foreground">
          Upload your master image and provide product details
        </p>
      </div>

      <ImageUpload
        onImageSelect={handleImageSelect}
        currentImage={masterImage}
        onClear={handleClearImage}
      />

      {masterImage && (
        <Card className="p-6">
          <div className="space-y-4">
            <div>
              <Label htmlFor="category">Product Category</Label>
              <Select
                value={productCategory}
                onValueChange={(value) => setProductCategory(value as ProductCategory)}
              >
                <SelectTrigger className="mt-1.5">
                  <SelectValue placeholder="Select a category" />
                </SelectTrigger>
                <SelectContent>
                  {AVAILABLE_CATEGORIES.map((category) => {
                    const config = getCategoryConfig(category);
                    return (
                      <SelectItem key={category} value={category}>
                        <div className="flex flex-col items-start">
                          <span className="font-medium">{config.label}</span>
                          <span className="text-xs text-muted-foreground">{config.description}</span>
                        </div>
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label htmlFor="title">Product Title</Label>
              <Input
                id="title"
                placeholder="e.g., Sunset Beach Landscape"
                value={productTitle}
                onChange={(e) => setProductTitle(e.target.value)}
                className="mt-1.5"
              />
            </div>
            <Button onClick={onStartCropping} size="lg" className="w-full">
              Continue to Cropping
            </Button>
          </div>
        </Card>
      )}
    </div>
  );
}
